const GROUPS = {
  blue: { bg: "#E0F2FE", text: "#0369A1", dot: "#0284C7" },
  amber: { bg: "#FEF3C7", text: "#B45309", dot: "#D97706" },
  green: { bg: "#DCFCE7", text: "#15803D", dot: "#16A34A" },
  red: { bg: "#FEE2E2", text: "#B91C1C", dot: "#DC2626" },
  purple: { bg: "#F3E8FF", text: "#7E22CE", dot: "#9333EA" },
  slate: { bg: "#F1F5F9", text: "#475569", dot: "#64748B" },
  teal: { bg: "#CCFBF1", text: "#0F766E", dot: "#14B8A6" },
};

const MAP = {
  // operational
  "New": "slate", "Awaiting Review": "slate", "Ready to Schedule": "blue",
  "Awaiting Purchase Order": "amber", "Awaiting Materials": "amber",
  "Scheduled": "blue", "Assigned": "blue", "Technician En Route": "teal",
  "In Progress": "amber", "Paused": "amber", "Completed on Site": "teal",
  "Awaiting Documentation": "amber", "Awaiting Manager Approval": "amber",
  "Further Work Required": "red", "Completed": "green", "Closed": "slate",
  "Cancelled": "slate",
  // billing
  "Not Ready": "slate", "Information Missing": "amber",
  "Awaiting Approval": "amber", "Ready for Invoicing": "purple",
  "Invoiced": "blue", "Paid": "green",
  "Ready to Send to Accounts": "purple", "Sent to Accounts": "blue",
  "Invoiced in Sage": "green", "Billing Query": "red", "Not Billable": "slate",
  // priority
  "Critical": "red", "High": "red", "Medium": "amber", "Low": "slate",
  // customer / defect / quote
  "Active": "green", "Prospect": "blue", "On Hold": "amber", "Inactive": "slate", "Archived": "slate",
  "Identified": "slate", "Under Review": "amber", "Immediate Action Required": "red",
  "Quotation Required": "amber", "Quotation Issued": "blue", "Awaiting Customer Approval": "amber",
  "Approved": "green", "Verified": "green", "Rejected by Customer": "red",
  "Draft": "slate", "Internal Review": "amber", "Approved Internally": "blue", "Issued": "blue",
  "Follow-up Due": "amber", "Customer Query": "amber", "Accepted": "green", "Rejected": "red",
  "Expired": "slate", "Converted to Job": "green",
  "Compliant": "green", "Action Required": "red",
  "Exported": "blue", "Query Raised": "red",
  "Operational": "green",
  // SLA / auto-billing
  "Achieved": "green", "Breached": "red", "Auto Billing": "purple",
};

export function statusColor(status) {
  return GROUPS[MAP[status] || "slate"];
}

export default function StatusBadge({ status, testid }) {
  if (!status) return <span className="text-slate-400">—</span>;
  const c = statusColor(status);
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap"
      style={{ backgroundColor: c.bg, color: c.text }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: c.dot }} />
      {status}
    </span>
  );
}
